export const PAGES = [
  ["overview", "概覽"],
  ["runners", "跑者資料"],
  ["demographics", "年齡與性別"],
  ["location", "地點分布"],
  ["activity", "時間與次數"],
  ["quality", "資料品質"],
] as const;

export type PageId = (typeof PAGES)[number][0];

export function Navigation({ current, onChange }: { current: PageId; onChange: (page: PageId) => void }) {
  return (
    <nav className="tabs" aria-label="儀表板分頁">
      <div className="tabs__track">
        {PAGES.map(([id, label], index) => (
          <button
            type="button"
            key={id}
            className={current === id ? "is-active" : ""}
            aria-current={current === id ? "page" : undefined}
            onClick={() => onChange(id)}
          >
            <span>{String(index + 1).padStart(2, "0")}</span> {label}
          </button>
        ))}
      </div>
    </nav>
  );
}
